import { Icon, IconProps } from '../Icon'

export const CancelIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      cancel
    </Icon>
  )
}
